import { render } from "./BlListFilterSelectManyToMany.vue?vue&type=template&id=48b9791e&scoped=true"
import script from "./BlListFilterSelectManyToMany.vue?vue&type=script&lang=js"
export * from "./BlListFilterSelectManyToMany.vue?vue&type=script&lang=js"

import "./BlListFilterSelectManyToMany.vue?vue&type=style&index=0&id=48b9791e&scoped=true&lang=scss"

import exportComponent from "/tmp/ee6909f6-e1a9-41e2-8541-cccc71f1c53b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b9791e"]])

export default __exports__